import React from 'react';
import styled from "@emotion/styled";

const Error = ({ message }) => {
    return (
        <ErrorParagraph>
            {message}
        </ErrorParagraph>
    );
}

const ErrorParagraph = styled.p`
    text-align: center;
    position: relative;
    padding: .35rem 1.25rem;
    border-radius: .3rem;
    font-weight: 600;
    color: #884b51;
    background-color: #e6bbbe;
    border: 2px solid #d38f96;
    margin-top: 14px;
`;


export default Error;